module.exports = __webpack_public_path__ + "static/media/short-background-placeholder.6a369b53.jpg";